<template>
  <div class="container py-5 admin-signin">
    <h1 class="h3">Administrator sign-in</h1>
    <p class="text-muted">
      Signing in is only needed to change this catalogue's configuration.
      Browsing the catalogue does not require an account.
    </p>

    <p v-if="signedIn">
      Signed in as <strong>{{ email }}</strong
      >, but this account has no Manager role for this catalogue, so the
      configuration screen is not available.
    </p>

    <a
      v-else-if="useOidc"
      id="admin-signin-button"
      class="btn btn-secondary"
      :href="loginUrl"
    >
      Sign in
    </a>

    <template v-else>
      <button
        id="admin-signin-button"
        type="button"
        class="btn btn-secondary"
        @click="showForm = true"
      >
        Sign in
      </button>
      <MolgenisSigninAny
        v-if="showForm"
        @signin="onSignedIn"
        @cancel="onCancel"
      />
    </template>

    <p class="mt-4 mb-0">
      <router-link to="/">Back to the catalogue</router-link>
    </p>
  </div>
</template>

<script setup>
//@ts-expect-error - the vendored library ships no types
import { MolgenisSignin } from "molgenis-components";
import { computed, ref } from "vue";
import {
  isOidcEnabled,
  isSignedIn,
  oidcLoginUrl,
} from "../functions/session.js";
import { useSettingsStore } from "../stores/settingsStore.js";

/* Same aliasing as App.vue does for Molgenis: the vendored components are
 * untyped, and the alias keeps the @ts-expect-error on the import alone. */
const MolgenisSigninAny = MolgenisSignin;

const settingsStore = useSettingsStore();

/* The vendored sign-in form is a modal, so the page keeps a button to open it
 * - and Cancel has a page to return to rather than an empty screen. */
const showForm = ref(false);

const session = computed(() => settingsStore.session);
const signedIn = computed(() => isSignedIn(session.value));
const email = computed(() => session.value?.email);
const useOidc = computed(() => isOidcEnabled(session.value));
const loginUrl = computed(() => oidcLoginUrl(window.location.href));

function onSignedIn() {
  /* A full page load rather than router.push(): the session lives in the
   * vendored MolgenisSession inside the navbar, which only refreshes itself
   * after its own sign-in. Reloading re-runs its `_session` query.
   *
   * Reloading this route rather than navigating to #/configuration keeps the
   * routing in one place: the guard on /signin forwards a Manager to the
   * Configuration screen, and leaves anyone else here with the explanation
   * above. */
  window.location.reload();
}

function onCancel() {
  showForm.value = false;
}
</script>

<style scoped>
.admin-signin {
  max-width: 40rem;
}
</style>
